// Order controls sequence on UI
export const CATEGORIES = {
  COMPETITIVE: 'Competitive Analysis',
  SEASONALITY: 'Seasonality',
  AUDIENCE: 'Audience Characteristics',
  DEMOGRAPHICS: 'Demographics',
  CLIENT: 'Client Recommendation',
  SHARETHIS: 'Sharethis',
  TRANSITION: 'Transition',
  MARKETING: 'Marketing',
}

// Define which fields will be editable for each slide
export const EDIT_FIELDS = {
  HEADER: 'header',
  SEC1: 'section_1', // intro, outro
  TRANSITION_TITLE: 'title',
  ENTITIES: 'selected_entities',
  TOPICS: 'topics',
  RECOMMENDED_SEGMENTS_1: 'section_1',
  RECOMMENDED_SEGMENTS_2: 'section_2',
  RECOMMENDED_SEGMENTS_3: 'recommended_segments_signals',
  LOOKBACK: 'lookback',
  SOCIAL_CHANNELS: 'social_channels',
}

export const AVAILABLE_SLIDES = [
  {
    template: 'ShareThis_Overview',
    title: 'ShareThis Overview',
    category: CATEGORIES.SHARETHIS,
    tags: [],
    editableFields: [],
  },
  {
    template: 'Competitive_Landscape',
    title: 'Competitive Landscape',
    category: CATEGORIES.COMPETITIVE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.TOPICS],
  },
  {
    template: 'Entity_Comparison',
    title: 'Engagement Comparison',
    category: CATEGORIES.COMPETITIVE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.TOPICS],
  },
  {
    template: 'Sentiment',
    title: 'Competitive Sentiment',
    category: CATEGORIES.COMPETITIVE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.TOPICS],
  },
  {
    template: 'Seasonality',
    title: 'Recent Trends by Topics',
    category: CATEGORIES.SEASONALITY,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.TOPICS],
  },
  {
    template: 'Seasonality_by_Category',
    title: 'Recent Trends by Category',
    category: CATEGORIES.SEASONALITY,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.ENTITIES],
  },
  {
    template: 'Audience_Trend',
    title: 'Audience Trend',
    category: CATEGORIES.SEASONALITY,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.ENTITIES],
  },
  {
    template: 'Audience_Comparison',
    title: 'Audience Comparison',
    category: CATEGORIES.SEASONALITY,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.ENTITIES],
  },
  {
    template: 'Device_and_Mobile_OS',
    title: 'Device Usage',
    category: CATEGORIES.AUDIENCE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER],
  },
  {
    template: 'Social_Networks',
    title: 'Preferred Social Channels',
    category: CATEGORIES.AUDIENCE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.SOCIAL_CHANNELS],
  },
  {
    template: 'L2_Categories_and_L3_Categories',
    title: 'Passion Points',
    category: CATEGORIES.AUDIENCE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.ENTITIES],
  },
  {
    template: 'L2_and_L3_Categories_WordCloud',
    title: 'Category Cloud',
    category: CATEGORIES.AUDIENCE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.ENTITIES],
  },
  {
    template: 'Topics_Cloud',
    title: 'Topics Cloud',
    category: CATEGORIES.AUDIENCE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER, EDIT_FIELDS.LOOKBACK, EDIT_FIELDS.TOPICS],
  },
  {
    template: 'Top_Indexing_States',
    title: 'Top U.S. States',
    category: CATEGORIES.AUDIENCE,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER],
  },
  {
    template: 'Audience_Overview',
    title: 'Audience Overview',
    category: CATEGORIES.DEMOGRAPHICS,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER],
  },
  {
    template: 'Income_Distribution',
    title: 'Income Distribution',
    category: CATEGORIES.DEMOGRAPHICS,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER],
  },
  // {
  //   template: 'Income_Distribution_by_Age_and_Gender',
  //   title: 'Income Distribution by Age and Gender',
  //   category: CATEGORIES.DEMOGRAPHICS,
  //   tags: [],

  //   editableFields: [EDIT_FIELDS.HEADER],
  // },
  {
    template: 'Income_Distribution_by_Age',
    title: 'Income by Age',
    category: CATEGORIES.DEMOGRAPHICS,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER],
  },
  {
    template: 'Income_Distribution_by_Gender',
    title: 'Income by Gender',
    category: CATEGORIES.DEMOGRAPHICS,
    tags: [],
    editableFields: [EDIT_FIELDS.HEADER],
  },
  {
    template: 'Recommended_Segments',
    title: 'Audiences To Activate',
    category: CATEGORIES.CLIENT,
    tags: [],
    editableFields: [
      EDIT_FIELDS.HEADER,
      EDIT_FIELDS.RECOMMENDED_SEGMENTS_1,
      EDIT_FIELDS.RECOMMENDED_SEGMENTS_2,
      EDIT_FIELDS.RECOMMENDED_SEGMENTS_3,
    ],
  },
  {
    template: 'Marketing',
    title: 'Marketing Slides',
    category: CATEGORIES.MARKETING,
    tags: [],
    editableFields: [],
  },
  {
    template: 'Transition',
    title: 'Transition',
    category: CATEGORIES.TRANSITION,
    tags: [],
    editableFields: [EDIT_FIELDS.TRANSITION_TITLE],
  },
]

export const DEPRECATED_SLIDES = {
  Competitive_Landscape_Pie_Chart: 'Use "Engagement Comparison" instead.',
  Competitive_Landscape_Bar_Chart: 'Use "Competitive Sentiment" instead.',
}

export const MARKETING_SLIDES = [
  'Marketing_1',
  'Marketing_2',
  'Marketing_3',
  'Marketing_4',
  'Marketing_5',
  'Marketing_6',
]

export const DEFAULT_SLIDES = ['Intro', 'ShareThis_Overview', 'Outro']

export const BASE_SLIDES = [
  {
    template: 'Intro',
    title: 'Intro',
    category: '',
    tags: [],
    editableFields: [EDIT_FIELDS.SEC1],
  },
  {
    template: 'Outro',
    title: 'Outro',
    category: '',
    tags: [],
    editableFields: [EDIT_FIELDS.SEC1],
  },
]

export const SLIDES = {
  INTRO: BASE_SLIDES[0].template,
  OUTRO: BASE_SLIDES[1].template,
  MARKETING: 'Marketing',
}
